var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress"
  }, _vm._l((_vm.values), function(progress) {
    return _c('div', {
      staticClass: "progress-bar",
      class: [progress.type ? ("bg-" + (progress.type)) : '', _vm.striped ? 'progress-bar-striped' : '', _vm.animated ? 'progress-bar-animated' : ''],
      style: ({
        width: ((progress.value) + "%")
      }),
      attrs: {
        "role": "progressbar",
        "aria-valuenow": ("" + (progress.value)),
        "aria-valuemin": 0,
        "aria-valuemax": "100"
      }
    }, [_vm._t("default")], 2)
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73e28b57","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/progress/Progress.vue
// module id = 188
// module chunks = 19